import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class WeightLabelService {
    static getWeightLabelItems(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`weight-label-items?filter=${qs}`, pageNumber));
    }
    static saveManualWeight(dto) {
        return lastValueFrom(BaseService.post(`weight-label-item-weight`, dto));
    }
    static printLabelsRange(dto) {
        return lastValueFrom(BaseService.post(`weight-label-print-range`, dto));
    }
}
